<div [ngStyle]="setMyStyles2()"  id="playlist" cdkDrag>

    <mat-card align="right">
        <mat-toolbar>
            <button mat-icon-button>
                <mat-icon >zoom_out_map</mat-icon>
            </button>
            <button mat-icon-button>
                <mat-icon [matMenuTriggerFor]="menu">aspect_ratio</mat-icon>
            </button>
            <span class="example-fill-remaining-space"></span>
            <button align="right" mat-icon-button (click)="sendClickPlaylist()" color="warn">
                <mat-icon >close</mat-icon>
            </button>
        </mat-toolbar>
    </mat-card>

        <iframe
         height="100%" width="100%"
            *ngIf="showVideo"
            [src]="playThisItem | safe"
            frameborder="0" allowfullscreen>
        </iframe>

    <mat-card>
        <mat-grid-list cols="1" rowHeight="30px">
            <mat-grid-tile>
                <marquee scrollamount="50" scrolldelay="2000">
                    {{playThisItemVideoName}}
                </marquee>
            </mat-grid-tile>
        </mat-grid-list>
    </mat-card>
</div>


<mat-menu #menu="matMenu">
    <button (click)="resize('113px', '200px')" mat-menu-item>
        <mat-icon>photo_size_select_small</mat-icon>
        <span>113px x 200px</span>
    </button>
    <button (click)="resize('226px', '400px')" mat-menu-item>
        <mat-icon>photo_size_select_large</mat-icon>
        <span>226px x 400px</span>
    </button>
    <button (click)="resize('452px', '800px')" mat-menu-item>
        <mat-icon>photo_size_select_actual</mat-icon>
        <span>452px x 800px</span>
    </button>
</mat-menu>






<!-- <div class="bottomfixedplaylist" id="playlist">
    <mat-card  color="primary">
        <table width="100%" cellpadding="0" cellspacing="0"  >
            <tr>
                <td width="10%" height="0"  style="text-align: center " >
                        <iframe width="88"  height="50"
                            *ngIf="showVideo"
                            [src]="playThisItem | safe"
                            frameborder="0" allowfullscreen
                        ></iframe>
                </td>
                <td width="60%" style="text-align: left">
                    <table align="left" cellpadding="0" cellspacing="0" id="playerControll" >
                        <tbody>
                            <tr >
                                <td width="10%" height="0"  style="text-align: center " >
                                    <button mat-icon-button matTooltip="{{'keyword_$255' | translate}}" class="playlistButton">
                                        <mat-icon>skip_previous</mat-icon>
                                    </button>
                                </td>
                                <td width="10%" height="0"  style="text-align: center " >
                                    <button mat-icon-button matTooltip="{{'keyword_$253' | translate}}" class="playlistButton">
                                        <mat-icon>play_arrow</mat-icon>
                                    </button>
                                </td>
                                <td width="10%" height="0"  style="text-align: center " >
                                    <button mat-icon-button matTooltip="{{'keyword_$254' | translate}}" class="playlistButton">
                                        <mat-icon>skip_next</mat-icon>
                                    </button>
                                </td>
                                <td width="10%" height="0"  style="text-align: center " >
                                    <button mat-icon-button matTooltip="{{'keyword_$256' | translate}}" class="playlistButton">
                                        <mat-icon >stop</mat-icon>
                                    </button>
                                </td>
                                <td width="10%" height="0"  style="text-align: center " >
                                    <button mat-icon-button matTooltip="{{'keyword_$252' | translate}}" class="playlistButton">
                                        <mat-icon >fullscreen</mat-icon>
                                    </button>
                                </td>
                                <td width="10%" height="0"  style="text-align: center " >
                                    <button mat-icon-button (click)="showPlaylistSongs = !showPlaylistSongs" class="playlistButton">
                                        <mat-icon matBadge="{{tracksInPlaylist}}" matBadgeColor="primary" matTooltip="{{'keyword_$250' | translate}}"  *ngIf="showPlaylistSongs" >expand_less</mat-icon>
                                        <mat-icon matBadge="{{tracksInPlaylist}}" matBadgeColor="primary" matTooltip="{{'keyword_$251' | translate}}" *ngIf="!showPlaylistSongs">expand_more</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
                <td width="30%" style="text-align: center">
                    <marquee scrollamount="50" scrolldelay="2000">
                        {{playThisItemVideoName}}
                    </marquee>
                </td>
            </tr>
        </table>
    </mat-card>
    <mat-card *ngIf="showPlaylistSongs">
        <div *ngFor="let item of trackslist">
            <iframe width="88"  height="50"
                [src]="item.url | safe"
                frameborder="0" allowfullscreen
            ></iframe>
        </div>
        <img src="https://images.unsplash.com/photo-1471421298428-1513ab720a8e?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=200&fit=max&s=df2fad59288b3a5100eef7eeec73605c" (click)="addtoPlaylist(tracks)" height="50px" alt="">
    </mat-card>
</div> -->
